<template>
    <p
        v-if="showPriceDisclaimer"
        class="cz2__disclaimer"
    >
        {{ $t('PRICE_DISCLAIMER') }}
    </p>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__disclaimer {
            color: color(v2YellowLight);
            font-size: 13px;
            font-weight: 700;
            font-family: 'Open Sans', sans-serif;
            text-transform: none;
        }
    }
</style>

<script>
    export default {
        computed: {
            hasTranslation() {
                return this.$t('PRICE_DISCLAIMER')?.length > 0;
            },

            showPriceDisclaimer() {
                return this.hasTranslation;
            },
        },
    };
</script>
